import React, {Component} from 'react';
import {connect} from 'react-redux';
import StackOptions from './stack-options';
import Action from 'components/organisms/nhl-legacy-team-stacking/actions';
import ChooseTeamsRandomly from './choose-teams-randomly';
import CombinationOptions from './combination-options';

class Stacks extends Component {
    componentDidMount() {
        this.props.dispatch(Action.setTeams(this.props.games));
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        this.props.dispatch(Action.setTeams(this.props.games));
    }
    render() {
        return (
            <div className="white-box">
                <h2 className="mb15">Stack Rules</h2>
                <div className="checkbox mb15">
                    <ChooseTeamsRandomly/>
                </div>
                <CombinationOptions/>
                <div className="stack-filter">
                    <StackOptions stackNumber={1}/>
                    <StackOptions stackNumber={2}/>
                    <StackOptions stackNumber={3}/>
                </div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {
        playersData: {
            filters,
        },
    } = state;

    return {
        games: filters.games,
    }
}

export default connect(mapStatesToProps)(Stacks);
